var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tencent-map-wrapper", class: "layout-" + _vm.layout },
    [
      _vm.showApiKey
        ? _c("div", { staticClass: "api-key-display" }, [
            _c(
              "div",
              { staticClass: "api-key-content" },
              [
                _c("span", { staticClass: "api-key-label" }, [
                  _vm._v("当前腾讯地图API Key:"),
                ]),
                _c("code", { staticClass: "api-key-value" }, [
                  _vm._v(_vm._s(_vm.getCurrentApiKey())),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "copy-btn",
                    attrs: { type: "text", size: "mini" },
                    on: { click: _vm.copyApiKey },
                  },
                  [_vm._v(" 复制 ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "api-key-tip" }, [
              _vm._v(
                " 腾讯地图API Key已通过登录后自动获取，如需修改请联系系统管理员 "
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "map-workbench" }, [
        _c("div", { staticClass: "map-main" }, [
          _c("div", { staticClass: "map-container" }, [
            _c("div", {
              staticClass: "map-box",
              style: { height: _vm.mapHeight },
              attrs: { id: _vm.mapContainerId },
            }),
          ]),
        ]),
        _c("div", { staticClass: "map-side-panel" }, [
          _vm.showSearchButton
            ? _c(
                "div",
                { staticClass: "panel-section search-container" },
                [
                  _c("div", { staticClass: "panel-title" }, [
                    _vm._v("地址搜索"),
                  ]),
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "请输入地址关键词或经纬度搜索",
                        clearable: "",
                        size: "medium",
                      },
                      on: {
                        blur: _vm.hideSearchResults,
                        focus: _vm.showSearchResultsIfExists,
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.searchAddress($event)
                        },
                      },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function ($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            loading: _vm.searchLoading,
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.searchAddress },
                          slot: "append",
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                  _vm.searchResults.length > 0 && _vm.showSearchResults
                    ? _c(
                        "div",
                        { staticClass: "search-results" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-results-header" },
                            [
                              _c(
                                "span",
                                { staticClass: "search-results-title" },
                                [_vm._v("搜索结果")]
                              ),
                              _c("el-button", {
                                staticClass: "close-btn",
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  icon: "el-icon-close",
                                },
                                on: { click: _vm.closeSearchResults },
                              }),
                            ],
                            1
                          ),
                          _vm._l(_vm.searchResults, function (result, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "search-result-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.selectSearchResult(result)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "result-title" }, [
                                  _vm._v(_vm._s(result.title)),
                                ]),
                                _c("div", { staticClass: "result-address" }, [
                                  _vm._v(_vm._s(result.address)),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.showControls
            ? _c("div", { staticClass: "panel-section map-controls" }, [
                _c("div", { staticClass: "panel-title" }, [_vm._v("快捷操作")]),
                _c(
                  "div",
                  { staticClass: "map-action-list" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "control-btn",
                        attrs: {
                          type: "primary",
                          size: "medium",
                          loading: _vm.locationLoading,
                          icon: "el-icon-location",
                        },
                        on: { click: _vm.getCurrentLocation },
                      },
                      [_vm._v(" 当前位置 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "control-btn",
                        attrs: { size: "medium", icon: "el-icon-refresh" },
                        on: { click: _vm.resetMapCenter },
                      },
                      [_vm._v(" 重置地图 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.locationInfo && _vm.showLocationInfo
            ? _c("div", { staticClass: "panel-section location-info" }, [
                _c("div", { staticClass: "panel-title" }, [_vm._v("已选位置")]),
                _c("p", [
                  _c("strong", [_vm._v("详细地址：")]),
                  _vm._v(_vm._s(_vm.locationInfo.addr || "-")),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("经纬度：")]),
                  _vm._v(
                    _vm._s(_vm.locationInfo.lat) +
                      ", " +
                      _vm._s(_vm.locationInfo.lng)
                  ),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("定位精度：")]),
                  _vm._v(_vm._s(_vm.locationInfo.accuracy || 0) + "米"),
                ]),
              ])
            : _vm._e(),
          _vm.showTips
            ? _c("div", { staticClass: "map-tips" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _c("span", [_vm._v(_vm._s(_vm.tips))]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }